<template>
  <div class="styleCard">
    <h2>Brokers Management</h2>
    <div id="first-stage">
      <h4>Please Choose Operation:</h4>
      <div class="form-group">
        <div class="radio ">
          <label>
            <input
              checked=""
              id="optionsRadios1"
              name="optionsRadios"
              type="radio"
              v-on:change="optionChoose('ADD')"
              value="option1"
            />
            Add New Broker
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              id="optionsRadios2"
              name="optionsRadios"
              type="radio"
              v-on:change="optionChoose('EDIT')"
              value="option2"
            />
            Edit Existing Broker
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              id="optionsRadios3"
              name="optionsRadios"
              type="radio"
              v-on:change="optionChoose('DELETE')"
              value="option3"
            />
            Delete Broker
          </label>
        </div>
      </div>
    </div>
    <br />
    <div id="DeleteBroker" v-if="selectDelete">
      <h4>{{ type }} Broker</h4>
      <div class="form-group filter-multiselect">
        <label for="delNamesOptions">Choose Broker To Delete</label>
        <multiselect
          :options="dictionaries.general.brokers"
          @input="selectNameToEdit"
          id="delNamesOptions"
          label="name"
          track-by="id"
          v-model="selectedName"
        ></multiselect>
      </div>
      <span class="caution"> Caution! this operation is irreversible!</span>
      <div class="form-group">
        <div class="btnBoxLeft">
          <button
            @click="showBrokerMgmt()"
            class="bttn  bttn-red"
            type="button"
          >
            Cancel
          </button>
          <button @click="submitDelete()" class="bttn  bttn-blue" type="button">
            Delete
          </button>
        </div>
      </div>
    </div>
    <div id="brokerAddEdit" v-if="selectAdd || selectEdit">
      <h4>{{ type }} Broker</h4>
      <div class="form-group filter-multiselect" v-if="selectEdit">
        <label for="brokersOptions">Select Broker</label>
        <multiselect
          :options="dictionaries.general.brokers"
          @input="selectNameToEdit"
          id="brokersOptions"
          label="name"
          track-by="id"
          v-model="selectedName"
        ></multiselect>
      </div>
      <div id="first">
        <p>Fill Broker Details</p>
        <div class="form-group">
          <label for="broker_name">Broker Name:</label>
          <input
            class="form-control"
            id="broker_name"
            name="broker_name"
            placeholder="Enter Broker Name "
            required
            type="text"
            v-model="brokerName"
          />
        </div>
        <div class="form-group">
          <label for="broker_name">Contact Name:</label>
          <input
            class="form-control"
            id="contact_name"
            name="contact_name"
            placeholder="Enter Brokers Contact Name "
            required
            type="text"
            v-model="contactName"
          />
        </div>
        <div class="form-group">
          <label for="broker_name">Contact Skype:</label>
          <input
            class="form-control"
            id="contact_skype"
            name="contact_skype"
            placeholder="Enter Brokers Contact Skype"
            type="text"
            v-model="contactSkype"
          />
        </div>
        <div class="form-group">
          <label for="broker_name">Support Email:</label>
          <input
            class="form-control"
            id="contact_email"
            name="contact_email"
            placeholder="Enter Brokers Contact Skype"
            type="text"
            v-model="supportEmail"
          />
        </div>
        <div class="form-group">
          <label for="min_dep">Minimum Deposit $:</label>
          <input
            class="form-control"
            id="min_dep"
            name="min_dep"
            placeholder="Enter Brokers Minimum Deposit "
            type="number"
            v-model="minDeposit"
            min="0"
          />
        </div>
        <div class="form-group">
          <label for="min_dep">Orders Amount:</label>
          <input
            class="form-control"
            id="order_amount"
            name="min_dep"
            placeholder="Enter Oders Emount "
            type="number"
            v-model="ordersAmount"
            min="0"
          />
        </div>
        <div class="form-group">
          <label for="broker_name">Average CPA Cost $:</label>
          <input
            class="form-control"
            id="avg_cpa"
            name="avg_cpa"
            placeholder="Enter Brokers Average CPA "
            type="number"
            v-model="avgCpa"
            min="0"
          />
        </div>
        <div class="form-group filter-multiselect">
          <label for="broker_name">Regulated By:</label>
          <multiselect
            :options="regulation_types"
            v-model="regulation"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="start_date">Start Date:</label>
          <date-picker
            id="start_date"
            v-model="startDate"
            lang="en"
            type="date"
            format="YYYY-MM-DD"
            :first-day-of-week="1"
            input-class="form-control input-sm"
            :confirm="true"
          ></date-picker>
        </div>
        <div class="top-check-div">
          <label class="multi-check-label" for="active">
            <input
              type="checkbox"
              class="multi-check"
              :checked="active"
              id="active"
              value="0"
              v-model="isItActive"
            />
            Active
          </label>
          <label class="multi-check-label" for="twice">
            <input
              type="checkbox"
              class="multi-check"
              :checked="active"
              id="twice"
              value="0"
              v-model="countedTwice"
            />
            Count 1k Deposit Twice
          </label>
        </div>

        <br />
        <div class="form-group text-right">
          <button @click="showBrokerMgmt()" class="bttn bttn-red">
            Cancel
          </button>
          <button
            @click="submitAdd('add')"
            class="bttn bttn-blue"
            v-if="selectAdd"
          >
            {{ type }} Broker
          </button>
          <button
            @click="submitAdd('edit')"
            class="bttn bttn-blue"
            v-if="selectEdit"
          >
            {{ type }} Broker
          </button>
        </div>
        <br />
        <div v-if="errors.length">
          <b>Please correct the following error(s):</b>
          <ul>
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>

    <br />
    <br />
  </div>
</template>
<script>
import moment from "moment/moment";
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import apiClientCreator from "../../../helpers/api/request";
import DatePicker from "vue2-datepicker";

export default {
  name: "AddEditBrokersContainer",
  components: {
    Multiselect,
    DatePicker
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries"])
  },

  data() {
    return {
      type: "Add",
      selectAdd: true,
      selectDelete: false,
      selectEdit: false,
      errors: [],
      selectedName: "",
      id: "",
      brokerName: "",
      contactName: "",
      contactSkype: "",
      supportEmail: "",
      minDeposit: "",
      regulation: "",
      startDate: "",
      avgCpa: "",
      ordersAmount: "",
      isItActive: true,
      countedTwice: false,
      brokersOptions: [],
      regulation_types: [
        "No Regulation",
        "FCA",
        "ASIC",
        "SYSEC",
        "CFTC",
        "FSA",
        "ECRC",
        "FSC",
        "FSC of BVI"
      ]
    };
  },
  created: function() {
    //  this.fetchBrokers();
    //console.log(this.dictionaries.general.brokers)
  },

  methods: {
    checkActiveSelected() {
      this.active = !this.active;
    },

    addNewBroker: function(newBroker) {
      const apiClient = apiClientCreator("admin/broker");
      apiClient
        .post("", newBroker)
        //console.log(newBroker)
        .then(
          res => {
            if (res.status === 201) {
              alert(`The Broker ${newBroker.name} Added Successfully`);
              if (confirm("Are you want to Add another Broker ?")) {
                this.resetForm();
              } else {
                this.showBrokerMgmt();
              }
              this.updateDictionaries();
            }
          },
          () => {
            alert(
              `Cannot Add Broker: The Broker ${newBroker.name} is already registered, please try another Broker name`
            );
          }
        );
    },
    updateBroker: function(updatedBroker) {
      const apiClient = apiClientCreator(`admin/broker/${updatedBroker.id}`);
      apiClient.put("", updatedBroker).then(
        res => {
          if (res.status === 201) {
            alert(`The User ${updatedBroker.name} Updated Successfully`);
            if (confirm("Are you want to Update another Broker ?")) {
              this.resetForm();
            } else {
              this.showBrokerMgmt();
            }
            this.updateDictionaries();
          }
        },
        () => {
          alert(
            `Cannot Add Broker: The Broker ${updatedBroker.name} is already registered, please try another Broker name`
          );
        }
      );
    },

    deleteBroker: function(broker) {
      const apiClient = apiClientCreator(`admin/broker/${broker.id}`);
      apiClient.delete().then(
        res => {
          if (res.status === 201) {
            alert(`The Broker ${broker.name} Deleted Successfully`);
            if (confirm(`Do you want delete another ?`)) {
              this.resetForm();
            } else {
              this.showBrokerMgmt();
            }
            this.updateDictionaries();
            // this.fetchBrokers();
          }
        },
        () => {
          alert(
            `Cannot Delete Broker: The Broker ${broker.name} is not exist, please try another Broker or refresh the page`
          );
        }
      );
    },
    updateDictionaries() {
      this.$store.dispatch("clients/getGeneralDictionary").then(res => {
        this.$store.dispatch("clients/getActivityDictionary").then(res => {
          this.$store.dispatch("clients/getSalesPersonList").then(res => {});
        });
      });
    },
    showBrokerMgmt: function() {
      //this.$store.commit('clients/showAddEditUsers', true);
      this.$router.push("/");
      this.resetForm();
      this.type = "Add";
      this.selectAdd = true;
      this.selectDelete = false;
      this.selectEdit = false;
    },

    selectNameToEdit: function(data) {
      this.id = data.id;
      this.brokerName = data.name;
      this.contactName = data.contact_name;
      this.contactSkype = data.contact_skype;
      this.supportEmail = data.support_email;
      this.minDeposit = data.min_deposit;
      this.regulation = data.regulated;
      this.startDate = data.start_date;
      this.avgCpa = data.avg_cpa;
      this.isItActive = data.active;
      this.countedTwice = data.count_twice;
    },

    optionChoose: function(type) {
      switch (type) {
        case "ADD":
          this.selectAdd = true;
          this.selectDelete = false;
          this.selectEdit = false;
          this.type = "Add";
          this.resetForm();
          // this.fetchBrokers();
          break;
        case "EDIT":
          this.selectAdd = false;
          this.selectDelete = false;
          this.selectEdit = true;
          this.type = "Edit";
          this.resetForm();
          // this.fetchBrokers();
          break;
        case "DELETE":
          this.selectAdd = false;
          this.selectDelete = true;
          this.selectEdit = false;
          this.type = "Delete";
          this.resetForm();
          // this.fetchBrokers();
          break;
        default:
          "";
          break;
      }
    },

    resetForm: function() {
      (this.id = ""), (this.selectedName = "");
      this.brokerName = "";
      this.contactName = "";
      this.contactSkype = "";
      this.supportEmail = "";
      this.minDeposit = "";
      this.regulation = "";
      this.startDate = "";
      this.avgCpa = "";
      this.ordersAmount = "";
      this.isItActive = "";
      this.countedTwice = "";
      data.count_twice;
    },

    submitAdd: function(actionType) {
      if (this.brokerName && this.contactName && this.startDate) {
        const newData = {
          id: this.id,
          name: this.brokerName,
          contact_name: this.contactName,
          contact_skype: this.contactSkype,
          support_email: this.supportEmail,
          min_deposit: this.minDeposit,
          avg_cpa: this.avgCpa,
          regulated: this.regulation,
          start_date: moment(this.startDate).format("YYYY-MM-DD"), //this.startDate,
          orders_amount: this.ordersAmount,
          active: this.isItActive,
          count_twice: this.countedTwice
        };

        if (actionType === "add") {
          this.addNewBroker(newData);
        } else {
          this.updateBroker(newData);
        }
      }

      this.errors = [];
      //  const vm = this;
      //this.type = "";
      /*      console.log(vm.dictionaries.general.brokers);
      const found = vm.dictionaries.general.brokers.filter(function(element) {
        return element.name !== "FXTM";
      });
      if (vm.dictionaries.general.brokers.length !== found.length)
      {
        alert('found')
      }
console.log('kk',found)*/
      if (!this.brokerName) {
        this.errors.push("Broker Name field required.");
      }
      if (!this.contactName) {
        this.errors.push("Contact Name field required.");
      }
      if (!this.contactSkype) {
        this.errors.push("Contact Skype field required.");
      }
      if (!this.supportEmail) {
        this.errors.push("Support Email field required.");
      }
      if (!this.minDeposit) {
        this.errors.push("Minimum Deposit field required.");
      }
      if (!this.avgCpa) {
        this.errors.push("Average CPA field required.");
      }
      /*     if (!this.ordersAmount) {
        this.errors.push("Orders Amount field required.");
      }*/
      if (!this.regulation) {
        this.errors.push("Regulated By field required.");
      }
      if (!this.startDate) {
        this.errors.push("Start Date required.");
      }
      // if (!this.isItActive) {
      //   this.errors.push("Did you fo");
      // }
    },

    submitDelete: function() {
      this.errors = [];
      if (this.selectedName.length < 1) {
        this.errors.push("Choose Broker to Delete");
      } else {
        if (
          confirm(
            `You are going to Delete ${this.selectedName.name}, Are you sure ?`
          )
        ) {
          this.deleteBroker(this.selectedName);
          this.resetForm();
        }
      }
    }
  }
};
</script>
<style scoped>
input[type="radio"]:not(:checked) ~ .radio-sample {
  display: none;
}

.boxMain {
  max-width: 400px;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  top: 22px;
}

.btnBoxLeft {
  float: left;
}

.btnBoxLeft {
  float: right;
}

.caution {
  color: red;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: max-content;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 70px;
  right: 0;
  left: 0;
  width: 40%;
  padding: 20px;
  font-size: 12px;
}
.styleCard h2 {
  font-size: 17px;
}
.styleCard h4 {
  font-size: 14px;
}
.bttn {
  font-family: Montserrat;
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}

.top-check-div {
  display: inline-flex;
}

.multi-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}
</style>
